import { ref, defineComponent, onMounted, PropType, watch, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/store/auth.store';
import { useEnvStore } from '@/store/env.store';
import { storeToRefs } from 'pinia';
import { PARENT_ROUTE_NAMES } from '@/models/app-internal/env.model';
import { setTimezone } from '@marfa/bo-utils';

export default defineComponent({
  name: 'Root',
  props: {
    wlSlug: {
      type: String,
      required: true,
    },
    apiUrl: {
      type: String,
      required: true,
    },
    multibrandApiUrl: {
      type: String,
      required: true,
    },
    reportsPermissions: {
      type: String,
      default: '',
    },
    currentParentRouteName: {
      type: String as PropType<PARENT_ROUTE_NAMES>,
      default: '',
    },
  },
  setup (props) {
    const { token } = storeToRefs(useAuth());
    const root = ref();
    const { push: redirect, go } = useRouter();
    const { setEnv } = useEnvStore();

    const isBackofficeMode = computed(() => {
      return !!props.wlSlug && !!props.apiUrl;
    });

    onMounted(() => {
      if (!isBackofficeMode.value) {
        redirect({ name: 'home' });
      }

      if (!token.value && isBackofficeMode.value) {
        go(0);
      }

      setEnv(props);

      const timezone = localStorage.getItem('adminTimezone');

      if (timezone) {
        setTimezone(timezone);
      }
    });

    watch(props, (updatedProps) => {
      setEnv(updatedProps);
    });

    return {
      root,
      isBackofficeMode,
    };
  },
});
